import React, { ReactElement } from 'react';
import { StatusCodes } from 'http-status-codes';
import { usePageViewAnalytics } from 'b2b-apps/shop/analytics/hooks';
import { TEALIUM_PAGE_TYPE } from 'b2b-apps/shop/analytics/types/types';
import { InfoView } from 'b2b-apps/shop/common/components/InfoView';
import { useTranslate } from 'b2b-apps/shop/i18n/hooks';
import defaultImage from './assets/locked.svg';
import { ComponentType, Props } from './';

const UnloggedUserPage: ComponentType = ({
  iconType,
  image = defaultImage,
  onLoginClick,
  onHomepageClick,
  infoViewTestId,
}: Props): ReactElement => {
  const t = useTranslate();

  usePageViewAnalytics({
    pageType: TEALIUM_PAGE_TYPE.notAllowedPage,
    data: {
      server: {
        code: StatusCodes.UNAUTHORIZED,
      },
    },
  });

  const buttons = {
    primary: {
      text: t('Login'),
      onClick: onLoginClick,
    },
    secondary: {
      text: t('Homepage'),
      onClick: onHomepageClick,
    },
  };

  return (
    <InfoView
      image={image}
      title={t('Page accessible only to logged-in users')}
      iconType={iconType}
      buttons={buttons}
      testId={infoViewTestId}
    />
  );
};

export { UnloggedUserPage };
